import 'react';
import { formatCurrency } from '@atc/string-fns';
import { DebouncedInput } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function WalletInput(_ref) {
  let {
    name,
    label,
    value,
    supportingLink,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(DebouncedInput, {
      ...rest,
      name: name,
      id: `${name}-wallet`,
      value: value ? `${formatCurrency(value)}` : '$0',
      placeholder: "$0",
      label: label
    }), !!supportingLink && supportingLink]
  });
}
export { WalletInput as default };
